// extracted by mini-css-extract-plugin
module.exports = {"copiedIcon":"CopyText_copiedIcon__1xfOi","failedIcon":"CopyText_failedIcon__3ejVJ","defaultIcon":"CopyText_defaultIcon__389EW"};